module.exports = __webpack_public_path__ + "img/register-success.b0a54c30.svg";